import React, { Component } from "react";
import PropTypes from "prop-types";
import renderHTML from "react-render-html";
import {pushLinkItem} from "../../utils/datalayer";

class CmsContentWrapper extends Component {
    static defaultProps = {
        as: "div",
    };

    static propTypes = {
        html: PropTypes.string.isRequired,

        /** The wrapper element type (e.g., 'div', 'section', 'article') */
        as: PropTypes.oneOfType([
            PropTypes.string,      // "div", "section", "span", etc.
            //PropTypes.elementType,  custom component if desired
        ]),
    };

    componentDidMount() {
        if (this.container) {
            this.container.addEventListener("click", this.handleClick);
        }
    }

    componentWillUnmount() {
        if (this.container) {
            this.container.removeEventListener("click", this.handleClick);
        }
    }

    handleClick = (event) => {
        let target = event.target;

        while (target && target !== this.container) {
            if (target.tagName && target.tagName.toLowerCase() === "a") {
                pushLinkItem(target);
                break;
            }
            target = target.parentNode;
        }
    };

    render() {
        const { html, as: Component, ...rest } = this.props;

        return (
            <Component
                ref={(el) => (this.container = el)}
                {...rest}
            >
                { renderHTML(html) }
            </Component>
        );
    }
}

export default CmsContentWrapper;




// WEBPACK FOOTER //
// ./src/pages/common/CmsContentWrapper.js